export const formatWithCommas= (x) => {
  return x?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const validatePhone = (phone) => {
    
  if(!phone) return true;

  let phone_regrex = /^(\()?\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
  
  if(!phone_regrex.test(phone))
    return false
  
  return true;
}


export const validateAmount = (amount) => {
    
  if(!amount) return true;

  const amount_regrex = /^[0-9]*\.\d{1,2}$/;
  
  if(!amount_regrex.test(amount))
    return false
  
  return true;

}


export const validateFloat = (n) => {

  return !isNaN(parseFloat(n)) && !isNaN(n - 0)

}

export const validateNumber = (number) => {
    
  if(!number) return true;

  const number_regrex = /^[0-9]\d*$/;
  
  if(!number_regrex.test(number))
    return false
  
  return true;

}

export const validateEmail = (email) => {
    
  if(!email) return true;

  const email_regrex = /^$|^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
  
  if(!email_regrex.test(email))
    return false;
  
  return true;

}

;

export const currencyFormat = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
});